import _slicedToArray from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
export default function () {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var toggle = function toggle(newState) {
    if (newState !== undefined && newState !== state) {
      setState(newState);
    } else if (newState === undefined) {
      setState(!state);
    }
  };

  return [state, toggle];
}